import { render, staticRenderFns } from "./CatalogGlide.vue?vue&type=template&id=729ead4f&scoped=true&"
import script from "./CatalogGlide.vue?vue&type=script&lang=js&"
export * from "./CatalogGlide.vue?vue&type=script&lang=js&"
import style0 from "./CatalogGlide.vue?vue&type=style&index=0&id=729ead4f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "729ead4f",
  null
  
)

export default component.exports